import { DOMElement } from './DOMElement';

/**
 * Utility class in order to instantiate a polyfill version of input event.
 */
export class InputEvent {
  /**
   * Empty Ob1 Class.
   */
  static emptyOb1Class = 'form-control-empty';

  /**
   * Handle if ob1 event to lower or not the label for the input.
   *
   * @param {object} input - The input to inject the class.
   */
  static handleOb1Behaviour(input) {
    if (input.value === '') {
      InputEvent.toogleOb1Empty(input);
    } else {
      InputEvent.toogleOb1NotEmpty(input);
    }
  }

  /**
   * Toogle Ob1 Not Empty.
   *
   * @param {object} input - The input to inject the class.
   */
  static toogleOb1NotEmpty(input) {
    DOMElement.removeClass(InputEvent.emptyOb1Class, input);
  }

  /**
   * Toogle Ob1 Empty.
   *
   * @param {object} input - The input to inject the class.
   */
  static toogleOb1Empty(input) {
    DOMElement.addClass(InputEvent.emptyOb1Class, input);
  }
}
